import optinReducer from './reducers'

export const FETCH_OPTINS = 'marvel/optins/FETCH_OPTINS'

export type OptinState = ReturnType<typeof optinReducer>
